import { Container, Grid } from "@mui/material";
import styled from "@emotion/styled";
import {Typography} from "@mui/material";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const FaqContainer = styled(Container)`
    background-color:#000B29;
    padding-top:100px;
    padding-bottom:100px;
    display:flex;
    justify-content:center;
    flex-direction:column;
    align-items: center;
    @media(max-width: 900px){
        padding-top:50px;
    }
`
const Heading = styled(Typography)`
    font-size:25px;
    font-family:Emulogic-zrEw;
    font-weight:400;
    text-transform:uppercase;
    color:#fff;
    text-align:center;
`
const AccordianHeading = styled(Typography)`
    font-family:Emulogic-zrEw;
    font-size:15px;
    font-weight:400;
    color:#fff;
    @media(max-width: 749px){
        font-size:10px;
    }
`
const Accordiandesc =styled(Typography)`
    font-family:poppins;
    font-size:13;
    color:#fff;
    background:transparent;
`
const FaqGrid = styled(Grid)`
    margin-top:50px;
`
const AccordionWrapper = styled(Accordion)`
    background-color:transparent;
    border-bottom:1px solid #fff;
    padding-top:20px;
    padding-bottom:20px;
    svg{
        background: yellow;
        border-radius: 4px;
        font-size: 30px;
        color: #000;
    }
`
const PacMansContainer = styled(Container)`
background-color:#000B29;
`
function Faq(){
    return(
        <>
        <PacMansContainer maxWidth="xxl">
        <marquee direction="left">
            <img src="./assets/pacmans.png" alt=""/>
            <img src="./assets/pacmans.png"  alt=""/>
            <img src="./assets/pacmans.png"  alt=""/>
        </marquee>
        </PacMansContainer>
        <FaqContainer maxWidth="xxl" id="faq">
            <Grid container item xs={12} md={12} xl={8}>
                <Grid item xs={12}>
                    <Heading variant="h1">FAQ</Heading>
                </Grid>
                <FaqGrid item xs={12} sm={12} md={12}>
                <AccordionWrapper >
                    <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    >
                    <AccordianHeading>How can I earn rewards through Pacman?</AccordianHeading>
                    </AccordionSummary>
                    <AccordionDetails>
                    <Accordiandesc>
                    By playing and achieving high scores, you can earn Pacman tokens which can be exchanged
                     for various rewards and benefits.
                    </Accordiandesc>
                    </AccordionDetails>
                </AccordionWrapper>
                <AccordionWrapper>
                    <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                    >
                    <AccordianHeading>Is Pacman compatible with different platforms?</AccordianHeading>
                    </AccordionSummary>
                    <AccordionDetails>
                    <Accordiandesc>
                    No, Pacman is designed to be accessible across platforms that support it fully across various web browsers.
                    </Accordiandesc>
                    </AccordionDetails>
                </AccordionWrapper>
                <AccordionWrapper>
                    <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                    >
                    <AccordianHeading>What makes Pacman unique from traditional Pacman games?</AccordianHeading>
                    </AccordionSummary>
                    <AccordionDetails>
                    <Accordiandesc>
                    Pacman introduces the exciting concept of score-to-earn, where players are rewarded with tokens 
                    for their gaming achievements, adding a new layer of competition and incentive.
                    </Accordiandesc>
                    </AccordionDetails>
                </AccordionWrapper>
                </FaqGrid>
            </Grid>
        </FaqContainer>
        </>
    );
}

export default Faq;